/**
 * Safe getter for empresa fields from localStorage.
 * Used ONLY by non-React code that cannot use useEmpresa() hook.
 * React components should prefer useEmpresa() from empresaContext.
 */
export function getEmpresaField(field, defaultValue = null) {
    try {
        const raw = localStorage.getItem('empresa');
        if (!raw) return defaultValue;
        const empresa = JSON.parse(raw);
        return empresa?.[field] ?? defaultValue;
    } catch {
        return defaultValue;
    }
}
